/**
 * The user's message in a turn.
 *
 * Right-aligned and tinted with the corner nearest the sender squared off — the same treatment as
 * Weave's thread, so the two modules read as one product. It was previously a generic rounded box
 * capped at 72% width with no distinct shape, which made a long user message hard to tell apart from
 * the agent's reply above it.
 *
 * Long pastes scroll inside the bubble rather than pushing the answer off screen.
 */
export function TestingUserBubble({ content }: { content: string }) {
	if (!content.trim()) return null;
	return (
		<div className="flex justify-end">
			<div className="tst-user-bubble">{content}</div>
		</div>
	);
}
